<div class="offergroup">
  <img class="offergroup__logo" [src]="offerGroup?.seo?.image?.url" [alt]="offerGroup?.seo?.title" />
  <h3 class="offergroup__title">{{ offerGroup?.seo?.title }}</h3>
  <p class="offergroup__description">
    {{ offerGroup?.seo?.description }}
  </p>
  <div class="offergroup__button">
    <ng-content></ng-content>
  </div>
</div>
